import React, { useEffect } from "react";

const Header = () => {
  // Get default logo - this is the fallback if instance logo is not available
  const defaultLogo = require("../Assets/Images/usdlogo3.png");
  const [logo, setLogo] = React.useState(defaultLogo);
  const [hasTriedCustomLogo, setHasTriedCustomLogo] = React.useState(false);

  const updateLogo = () => {
    const settings = localStorage.getItem("instance_settings");
    
    if (!settings) {
      console.warn('[Header] No instance_settings found. Using default logo.');
      setLogo(defaultLogo);
      setHasTriedCustomLogo(false);
      return;
    }

    try {
      const parsed = JSON.parse(settings);
      
      // Check both brandLogo and brand_logo (backend might use different naming)
      const logoFilename = parsed.brandLogo || parsed.brand_logo;
      
      if (logoFilename && logoFilename.trim() !== '') {
        const trimmedFilename = logoFilename.trim();
        const logoUrl = `${process.env.REACT_APP_API_BASEURL}/uploads/${trimmedFilename}`;
        
        console.log('[Header] Loading instance logo:', logoUrl);
        console.log('[Header] Instance ID:', parsed.instance_id);
        
        // Set the logo URL - the img onError handler will fallback if it fails
        setLogo(logoUrl);
        setHasTriedCustomLogo(true);
      } else {
        console.log('[Header] No logo filename in instance_settings. Using default logo.');
        setLogo(defaultLogo);
        setHasTriedCustomLogo(false);
      }
    } catch (e) {
      console.error("[Header] Error parsing instance_settings:", e);
      setLogo(defaultLogo);
      setHasTriedCustomLogo(false);
    }
  };

  useEffect(() => {
    updateLogo();
    
    // Listen for storage changes (when user logs in/out or instance changes)
    const handleStorageChange = (e) => {
      if (e.key === 'instance_settings') {
        updateLogo();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom event that might be fired when instance_settings is updated
    const handleInstanceSettingsUpdate = () => {
      updateLogo();
    };
    
    window.addEventListener('instanceSettingsUpdated', handleInstanceSettingsUpdate);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('instanceSettingsUpdated', handleInstanceSettingsUpdate);
    };
  }, []);
  
  return (
    <div className="" id="header">
      <span className="logo">
        <img 
          alt="logo" 
          src={logo} 
          onError={(e) => {
            // Only fallback to default if we tried a custom logo and it failed
            if (hasTriedCustomLogo && logo !== defaultLogo) {
              console.warn('[Header] Instance logo failed to load, falling back to default:', logo);
              setLogo(defaultLogo);
              setHasTriedCustomLogo(false);
            } else {
              console.error('[Header] Logo failed to load:', logo);
            }
          }}
          onLoad={() => {
            if (hasTriedCustomLogo) {
              console.log('[Header] Instance logo loaded successfully');
            }
          }}
        />
      </span>
    </div>
  );
};

export default Header;
